import { z } from "zod";
import { Finite, IsoDate } from "./primitives";

/** FRED series we track, keyed by their FRED series ID. */
export const MacroSeriesId = z.enum([
  "T10Y2Y", // 10y minus 2y treasury spread — curve inversion
  "CPIAUCSL", // CPI, all urban consumers
  "UNRATE", // unemployment rate
  "DFF", // effective federal funds rate
  "DTWEXBGS", // trade-weighted USD index
  "VIXCLS", // CBOE volatility index
]);
export type MacroSeriesId = z.infer<typeof MacroSeriesId>;

export const MacroObservation = z.object({
  date: IsoDate,
  value: Finite.nullable(),
});
export type MacroObservation = z.infer<typeof MacroObservation>;

export const MacroSeries = z.object({
  id: MacroSeriesId,
  label: z.string(),
  units: z.string(),
  observations: z.array(MacroObservation),
});
export type MacroSeries = z.infer<typeof MacroSeries>;

/**
 * Coarse market regime.
 *
 * Deliberately three buckets, not a continuous score. The inputs (curve shape,
 * volatility, trend) are noisy enough that finer gradations would imply a
 * precision the data does not support.
 */
export const Regime = z.enum(["RiskOn", "Neutral", "RiskOff"]);
export type Regime = z.infer<typeof Regime>;

export const MacroSnapshot = z.object({
  asOf: IsoDate,
  regime: Regime,
  /** Plain-language reasons the regime classifier landed where it did. */
  drivers: z.array(z.string()),
  series: z.array(MacroSeries),
});
export type MacroSnapshot = z.infer<typeof MacroSnapshot>;
